import { render, staticRenderFns } from "./payment-gateways.vue?vue&type=template&id=796fa720&scoped=true"
import script from "./payment-gateways.vue?vue&type=script&lang=js"
export * from "./payment-gateways.vue?vue&type=script&lang=js"
import style0 from "./payment-gateways.vue?vue&type=style&index=0&id=796fa720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796fa720",
  null
  
)

export default component.exports